import { render } from "./EditCategoryForm.vue?vue&type=template&id=96634168"
import script from "./EditCategoryForm.vue?vue&type=script&lang=js"
export * from "./EditCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__